import * as type from "./type";

const initialState = {
  getVendorUsers: null,
  unassignedVendorUsers: null,
  addVendorUser: null,
  activeInactiveVendorUser: null,
  resendVendorUserEmail: null,
};

const AdminVendorUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_VENDOR_USER_LIST_REQUEST:
      return { ...state, getVendorUsers: null };
    case type.GET_VENDOR_USER_LIST_SUCCESS:
      return { ...state, getVendorUsers: action.payload };
    case type.GET_UNASSIGNED_VENDOR_USER_LIST_SUCCESS:
      return { ...state, unassignedVendorUsers: action.payload };
    case type.ASSIGN_VENDOR_USER_REQUEST:
      return { ...state, addVendorUser: null };
    case type.ASSIGN_VENDOR_USER_SUCCESS:
      return { ...state, addVendorUser: action.payload };
    case type.ADD_VENDOR_USER_REQUEST:
      return { ...state, addVendorUser: null };
    case type.ADD_VENDOR_USER_SUCCESS:
      return { ...state, addVendorUser: action.payload };
    case type.ACTIVE_INACTIVE_VENDOR_USER_REQUEST:
      return { ...state, activeInactiveVendorUser: null };
    case type.ACTIVE_INACTIVE_VENDOR_USER_SUCCESS:
      return { ...state, activeInactiveVendorUser: action.payload };
    case type.RESEND_VENDOR_USER_EMAIL_REQUEST:
      return { ...state, resendVendorUserEmail: null };
    case type.RESEND_VENDOR_USER_EMAIL_SUCCESS:
      return { ...state, resendVendorUserEmail: action.payload };
    case type.CLEAR_VENDOR_USER_REQ:
      return { ...state, addVendorUser: null };
    default:
      return {
        ...state,
      };
  }
};
export default AdminVendorUserReducer;
